import ButtonBasic from '../ButtonBasic'
import Icon from '../Icon'
import React from 'react'

interface IButtonTHProps {
  [prop: string]: any
  sortBy: string
  sortOrder: 'asc' | 'desc'
  onClick: (sortBy: any) => void
  currentSortBy: string
  children?: React.ReactNode
}

export function ButtonTH(props: IButtonTHProps) {
  const { sortBy, currentSortBy, sortOrder, onClick, children, className, ...otherProps } = props

  return (
    <ButtonBasic
      {...otherProps}
      className={`btn--tablehead flex-row ${className || ''}`}
      onClickEmit="value"
      value={sortBy}
      onClick={onClick}>
      <span className="margin-right-1ch">{children}</span>
      <Icon
        className={`${sortBy !== currentSortBy ? 'invisible' : ''} rotate-${sortOrder}`}
        name="arrow-down"
        color="var(--color-txt-muted)"
        bgPadding={1}
        height={16}
        width={12}
        top={2}
      />
    </ButtonBasic>
  )
}

export default React.memo(ButtonTH)
